import { useAjax, useMzMutation } from "@bsm/component";

export const useValidateBulkTimeoffCreationMutation = () => {
  const ajax = useAjax();
  return useMzMutation(async (data: { ids: number[] }) =>
    ajax.send({
      type: "POST",
      content_type: "application/json",
      url: `project/dayoff/validate`,
      data: { ids: data.ids.map(id => id.toString()) },
    }),
  );
};
